import { Form } from "react-bootstrap";

const Name = ({values,handleChange,touched,errors}) => {
    return (
        <>
            <Form.Group>
                <Form.Label className="required">Name</Form.Label>
                <Form.Control
                    name="name"
                    placeholder="Enter name"
                    value={values.name}
                    onChange={handleChange}
                />
                {touched.name && errors.name && <Form.Text className="text-danger">{errors.name}</Form.Text>}
            </Form.Group>
        </>
    )
}

export default Name;